<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>

                <li v-if="ckLoginAdmin" @mouseover="showSettingsMenu = true" @mouseleave="showSettingsMenu = false">
                    <img src="@/assets/icons/menuSettings.svg" />
                    <span>Configurações</span>
                    <div v-if="showSettingsMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('GabineteDepartamentosTabPage', 'GABINETE - CADASTRO DE DEPARTAMENTOS')">
                                <img src="@/assets/icons/menuOffice.svg" />
                                <span>Departamentos</span>
                            </li>

                            <li @click="setComponenteAtivo('GabineteTpPessoasTabPage', 'GABINETE - GRUPO DE PESSOAS')">
                                <img src="@/assets/icons/menuTipos.svg" />
                                <span>Grupos de Pessoas</span>
                            </li>

                            <li @click="selectOption('UsuariosTabPage', 'USUÁRIOS')">
                                <img src="@/assets/icons/menuUsers.svg" />
                                <span>Usuários</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('GabinetePessoasTabPage', 'GABINETE - CADASTRO DE PESSOAS')">
                    <img src="@/assets/icons/menuPessoas.svg" />
                    <span>Pessoas</span>
                </li>

                <li @click="setComponenteAtivo('GabineteAgendaEditPage', 'GABINETE - INCLUIR AGENDA')">
                    <img src="@/assets/icons/menuAgendaAdd.svg" />
                    <span>Inserir Agenda</span>
                </li>

                <li @click="setComponenteAtivo('GabineteAgendaTabPage', 'GABINETE - LISTA AGENDAMENTOS')">
                    <img src="@/assets/icons/menuCalendarList.svg" />
                    <span>Lista de Agendamentos</span>
                </li>

                <li @click="setComponenteAtivo('GabineteAgendaCalendarioPage', 'GABINETE - CALENDÁRIO AGENDAMENTOS')">
                    <img src="@/assets/icons/menuAgenda.svg" />
                    <span>Agenda</span>
                </li>

                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.svg" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('GabineteAniversariantesReportPage', 'GABINETE - RELATÓRIO DE ANIVERSARIANTES')">
                                <span>Aniversariantes</span>
                            </li>

                            <li @click="selectOption('GabineteRequisicoesReportPage', 'GABINETE - RELATÓRIO DE SOLICITAÇÕES')">
                                <span>Solicitações</span>
                            </li>
                        </ul>
                    </div>
                </li>

                <li @click="setComponenteAtivo('UsuarioViewPage', 'DADOS DO USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Meus Dados</span>
                </li>

                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GABINETE' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ loginStore.userData.nome }}</div>
                        <div class="establishment-name">{{ loginStore.userData.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='GabineteAgendaCalendarioPage'"><GabineteAgendaCalendarioPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAgendaEditPage'"><GabineteAgendaEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAgendaTabPage'"><GabineteAgendaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabinetePessoasTabPage'"><GabinetePessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='GabineteDepartamentosTabPage'"><GabineteDepartamentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteTpPessoasTabPage'"><GabineteTpPessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='GabineteAniversariantesReportPage'"><GabineteAniversariantesReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteRequisicoesReportPage'"><GabineteRequisicoesReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <!-- <div v-else><IpOSAdminDash /></div> -->
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';

import GabineteAgendaCalendarioPage from '../gabinete/GabineteAgendaCalendarioPage.vue';
import GabineteAgendaEditPage from '../gabinete/GabineteAgendaEditPage.vue';
import GabineteAgendaTabPage from '../gabinete/GabineteAgendaTabPage.vue';
import GabinetePessoasTabPage from '../cadastros/tabelas/GabinetePessoasTabPage.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU CONFIGURAÇÕES
import GabineteDepartamentosTabPage from '../cadastros/tabelas/GabineteDepartamentosTabPage.vue';
import GabineteTpPessoasTabPage from '../cadastros/tabelas/GabineteTpPessoasTabPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';

// SUBMENU RELATÓRIOS
import GabineteAniversariantesReportPage from '../reports/GabineteAniversariantesReportPage.vue';
import GabineteRequisicoesReportPage from '../reports/GabineteRequisicoesReportPage.vue';

const ckLoginAdmin= ref(false);
const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showRelatoriosMenu = ref(false);
const showSettingsMenu = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;

const menuIcon = computed(() => {
    return isCollapsed.value
        ? require('@/assets/icons/menuRight.svg')
        : require('@/assets/icons/menuLeft.svg');
});

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value   = page;
    nmTitulo.value            = titulo;
    showRelatoriosMenu.value  = false;
    showSettingsMenu.value    = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
    ckLoginAdmin.value = globalStore.ckadmin==='S';
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>

<style scoped src="@/assets/css/main.css"></style>
